import { getClosestScrollableElement } from 'anodum';
import bowser from 'yola-bowser';
import { connectedStore } from '../../../../store';
import view from '../../../../view';

function preventIOSElasticScrollPropagation(event) {
  if (!bowser.ios) return;

  event.stopPropagation();

  const store = connectedStore.get();
  const state = store.getState();
  const focusedElementId = view.selectors.getFocusedElement(state);

  if (focusedElementId !== null) {
    return;
  }

  const { frameElement } = this.ownerDocument.defaultView;
  const scrollableElement = getClosestScrollableElement(frameElement);

  if (scrollableElement.scrollTop < 1) {
    scrollableElement.scrollTop = 1;
    event.preventDefault();
    return;
  }

  const maxPossibleScrollPosition =
    scrollableElement.scrollHeight - scrollableElement.offsetHeight - 1;

  if (scrollableElement.scrollTop > maxPossibleScrollPosition) {
    scrollableElement.scrollTop = maxPossibleScrollPosition;
    event.preventDefault();
  }
}

export default preventIOSElasticScrollPropagation;
